export const isPackTempo = value => String(value).trim() !== '' && Number.isSafeInteger(Number(value)) && Number(value) > 0;
